import {
  Breadcrumb,
  ConfigProvider,
  DatePicker,
  Input,
  Pagination,
  Select,
  Tooltip,
  Typography
} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
// import './style.scss';

import { SearchOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { PaginationProps } from 'antd/lib';
import viVN from 'antd/locale/vi_VN';
import { IListHistoryLog } from '../../../api/Customer_V2/customerApi_V2';
import { getListSystemLog } from '../../../api/groupPermission/groupPermissionApi';
import { NodataTable } from '../../../components/NoDataTable';
import { NO_DATA } from '../../../env';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { formatNumber } from '../../../services/mixin';
import { dataPagination, formatDateToDMY, genderLinkForLogV4 } from '../../../until';
import { IPagination } from '../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup';
import { getListHistoryCardIssuance } from '../../../api/rank/benefitApi';
import { Link } from 'react-router-dom';

interface IActivityLog {
  id: number;
  name: string;
  email: string;
  time: string;
  action: string;
}

const { RangePicker } = DatePicker;
const { Title } = Typography;
const { Option } = Select;


interface IFilter {
  search?: string;
  dateStart: string;
  dateEnd: string;
}

const initFilter: IFilter = {
  search: undefined,
  dateStart: "" as string,
  dateEnd: "" as string,
};

const CardIssuanceHistory: React.FC = () => {
  const pushLoading = useLoading()
  const pushToast = useToast();

  const [filters, setFilters] = useState<IFilter>(initFilter)
  const [pagination, setPagination] = useState<IPagination>({ current: 1, pageSize: 10, total: 0 })

  const [listSystemLog, setListSystemLog] = useState<IListHistoryLog[]>([])

  const columnDefs: ColDef<IListHistoryLog>[] = useMemo(() => [
    {
      headerName: 'Họ và tên nhân viên',
      width: 220,
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return params.data?.fullname ?? NO_DATA;
      },
    },
    {
      headerName: 'Email',
      width: 280,
      cellStyle: {
        color: '#666666',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return params.data?.email ?? NO_DATA;
      },
    },
    {
      headerName: 'Thời gian',
      width: 180,
      cellStyle: {
        color: '#666666',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        const [date, time] = params.data?.createdAt.split(" ") ?? []
        const dateTmp = formatDateToDMY(date ?? "")
        return dateTmp ? (time + " " + dateTmp) : NO_DATA;
      },

    },
    {
      headerName: 'Tên khách hàng/ Tổ chức ',
      width: 180,
      cellStyle: {
        color: '#666666',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return params.data?.customerName ?? NO_DATA;
      },

    },
    {
      headerName: 'Mã thẻ ',
      width: 180,
      cellStyle: {
        color: '#666666',
        paddingLeft: '16px',
        paddingRight: '16px',
      },
      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return params.data?.cardIssuanceCode ?? NO_DATA;
      },

    },
    {
      headerName: 'Hành động',
      flex: 1,
      minWidth: 350,
      cellStyle: {
        color: '#333333',
        paddingLeft: '16px',
        paddingRight: '16px',
      },

      cellRenderer: (params: { data?: IListHistoryLog }) => {
        return <Tooltip
          placement="right"
          color="white"
          title={
            <div className="custom-page-css flex flex-col gap-1" style={{ color: "#000" }}>
              {params?.data?.HistorySummaries?.map((item, i) => (
                <div key={i}>{item.description}</div>
              ))}
            </div>
          }
        >
          <span className="custom-page-css " >
            {genderLinkForLogV4(params?.data?.HistorySummaries[0])}
          </span>
        </Tooltip>
      },
    },
  ], [listSystemLog]);


  const gListHistoryCardIssuance = useDebounce(async (
    pageNumber: number = 1, limit: number = 10,
  ) => {
    pushLoading(true)
    const { dateEnd, dateStart, search } = filters
    const dateEndTmp = dateEnd.length > 2 ? dateEnd : undefined
    const dateStartTmp = dateStart.length > 2 ? dateStart : undefined

    const result = await getListHistoryCardIssuance(
      undefined,
      limit,
      pageNumber,
      search,
      dateStartTmp,
      dateEndTmp
    );
    if (result?.status) {
      setListSystemLog(result.data)

      setPagination({ current: pageNumber, total: result.total, pageSize: limit })
    } else {
      pushToast(result?.message, 'error', 2000)
    }
    pushLoading(false)
  }, 1000)

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListHistoryCardIssuance(pageNumber, pageSize)
  }

  useEffect(() => {
    gListHistoryCardIssuance()
  }, [filters])
  return (

    <div className="notification-templates-management">
      <Layout>
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Phát hành thẻ</a>,
            },
            {
              title: 'Lịch sử',
            },
          ]}
        />
        <div className='title-page title-btn-back ctrl-title-vouche'>
          <Link to="/member-card/card-issuance" className="icon-svg">
            <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.6564 7.80321H4.04305L10.3955 2.37463C10.4971 2.28713 10.4354 2.12463 10.3012 2.12463H8.69582C8.62508 2.12463 8.55796 2.14963 8.50536 2.19428L1.65045 8.04963C1.58767 8.10321 1.53732 8.16944 1.50281 8.24385C1.4683 8.31825 1.45044 8.39909 1.45044 8.48088C1.45044 8.56268 1.4683 8.64352 1.50281 8.71792C1.53732 8.79233 1.58767 8.85856 1.65045 8.91213L8.54526 14.8032C8.57247 14.8264 8.60512 14.8389 8.63959 14.8389H10.2993C10.4336 14.8389 10.4953 14.6746 10.3937 14.5889L4.04305 9.16035H14.6564C14.7363 9.16035 14.8016 9.09606 14.8016 9.01749V7.94606C14.8016 7.86749 14.7363 7.80321 14.6564 7.80321Z" fill="currentColor" fillOpacity="0.88" />
            </svg>
          </Link>
          Lịch sử phát hành thẻ
        </div>
        <div className="custom-page-css flex flex-col gap-5">
          <div className="custom-page-css w-full flex items-center gap-4">

            <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
              <Input
                placeholder="Tìm kiếm theo hành động"
                className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                value={filters.search}
                onChange={(e) => setFilters({ ...filters, search: e.target.value })}
              />
              <div className="border-l-F2F4F7 h-full d-flex align-center">
                <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
              </div>
            </div>

            <ConfigProvider locale={viVN}>
              <RangePicker
                className="custom-input-date py-6px"
                // open={true}
                placeholder={["Bắt đầu", "Kết thúc"]}
                format="DD/MM/YYYY"
                allowClear
                value={
                  filters.dateStart && filters.dateEnd ?
                    [
                      dayjs(filters.dateStart),
                      dayjs(filters.dateEnd),
                    ] :
                    null
                }
                onCalendarChange={(dates) => {
                  setFilters({
                    ...filters,
                    dateStart: dates?.[0]?.format("YYYY/MM/DD") ?? "",
                    dateEnd: dates?.[1]?.format("YYYY/MM/DD") ?? "",
                  },
                  );
                }}
              />
            </ConfigProvider>
          </div>

          <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
            <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
              <AgGridReact
                className="my-auto-height-grid" getRowStyle={(params: any) => ({
                  backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                })}
                rowData={listSystemLog}
                rowHeight={55}
                columnDefs={columnDefs}
                overlayNoRowsTemplate={NodataTable}
                suppressDragLeaveHidesColumns={true}
              />

            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>

        </div>





      </Layout>
    </div>
  );
};

export default CardIssuanceHistory;